import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import "./assets/css/common/global.scss";
import "./assets/css/common/clear.css";
import "./assets/css/common/iconfont.css";


import 'element-ui/lib/theme-chalk/index.css'
import element from './element/index'
Vue.use(element)


// 引入需全局注册的组件
import Pagination from "./components/Pagination.vue"; //分页组件
import BreadCrumb from "./components/BreadCrumb.vue"; //面包屑

Vue.component("pagination", Pagination);
Vue.component("BreadCrumb", BreadCrumb);
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
